
import Appdownload from "../../Components/Appdownload"
const DownloadPage = (props:any) => {

    return <>
        <Appdownload />
    </>
}

export default DownloadPage